import './App.css';
import ContainerFather from './Components/ContainerFather'

function App() {

  return (
    <div className="App">
      <h1 id="title">
        Weather App Casanova
      </h1>
      <ContainerFather/>
    </div>
  );
}

export default App;
